<template>
  <div
    class="user-newsletter-delivery-history"
  >
    <div>
      <p class="paged-key">
        <span
          class="paged-key-label"
        >
          Delivery history key
        </span>
        <span class="history badge badge-warning">
          Queued {{ deliveryIcon('queued') }}
        </span>
        <span class="history badge badge-primary">
          Sent {{ deliveryIcon('sent') }}
        </span>
        <span class="history badge badge-success">
          Delivered {{ deliveryIcon('delivered') }}
        </span>
        <span class="history badge badge-danger">
          Bounced  {{ deliveryIcon('bounced') }}
        </span>
      </p>
    </div>

    <pagination
      ref="pagination"
      :pageSize="$root.defaultPageSize"
      :resourceUrl="this.apiUrl('/users/' + this.userId + '/newsletter_statuses', true)"
      :orderBy="orderBy"
      orderType="DESC"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :class="$root.listItemClasses + ' ' + deliveryClass(item.status)"
          :to="{
            name: 'newsletter_recipient',
            params: {
              newsletterId: item.newsletter_id,
              newsletterRecipientId: item.id
            }
          }"
        >
          <span :class="'history ' + item.status">
            {{ item.newsletter.attributes.subject }}
          </span> {{ deliveryIcon(item.status) }}
        </router-link>
      </template>
    </pagination>
  </div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    return {
      orderBy: 'created_at'
    }
  },

  components: {
    pagination: Pagination
  },

  props: {
    userId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  computed: {
    icons () {
      return {
        'bounced': '❕',
        'delivered': '📨',
        'queued': '📬',
        'sent': '📤'
      }
    }
  },

  created () {
    this.$on('searchComplete', this.onPageSuccess)
  },

  methods: {
    deliveryClass (status) {
      let className = 'dark'

      switch (status) {
        case 'queued':
          className = 'info'
          break
        case 'sent':
          className = 'primary'
          break
        case 'delivered':
          className = 'success'
          break
        case 'bounced':
          className = 'danger'
      }

      return `list-group-item-${className}`
    },

    deliveryIcon (status) {
      return this.icons[status]
    },

    formattedDate (d) {
      return this.$root.displayDateTimeFmt(d)
    },

    onPageSuccess (response) {
      this.transactions = this.processSuccess(response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserNewsletterDeliveryHistory.vue